import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";
import { renderUserName } from "../../../utils/constants";

export const UsersSlider = () => {
  const { id } = useParams();

  const { user } = useSelector(state => state.userControl);

  const prestationDetailMenu = {
    title: id === "new" ? routes.users().new.title : renderUserName(user),
    root: routes.users,
    children: [routes.users(id).detail],
  };

  return <RenderMenuSider menu={prestationDetailMenu} />;
};
